// Extraction priority of a section, as the Library shows it: the three priorities in order (P1 to P3), the hint that explains them, and the pill (P1 in brand blue, P2 and P3 in neutral, read as "Priority P1" by screen readers, and a dash when the section has none).
import type { RequirementFilters } from "@/api/__generated__";
import { Badge } from "@/components/ui/badge";

export type Priority = NonNullable<RequirementFilters["priority"]>[number];

export const PRIORITIES = ["P1", "P2", "P3"] as const satisfies readonly Priority[];

export const PRIORITY_HINT = "Extraction priority of the section, as set in the Library.";

export function PriorityBadge({ priority, className }: { priority: string | null; className?: string }) {
  if (priority === null) {
    return <span className="text-muted-foreground">–</span>;
  }
  return (
    <Badge variant={priority === "P1" ? "brand" : "neutral"} className={className}>
      <span aria-hidden>{priority}</span>
      <span className="sr-only">{`Priority ${priority}`}</span>
    </Badge>
  );
}
